import * as React from 'react';
import type { BreadcrumbList, WithContext } from 'schema-dts';

import { RenderSEOSchema } from './Render';

type Breadcrumb = {
  name: string;
  path: string;
};

export function BreadcrumbSchema({ items }: { items: Breadcrumb[] }) {
  const schemaData: WithContext<BreadcrumbList> = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: `https://transcend.io${item.path}`,
    })),
  };

  return <RenderSEOSchema schemaData={schemaData} />;
}
